import { SyncModal } from "@/components/sync/SyncModal";
import { useStravaSync } from "@/hooks/useStravaSync";
import { Outlet } from "react-router-dom";

export default function SyncLayout() {
  useStravaSync();

  return (
    <>
      <Outlet />
      <SyncModal />
    </>
  );
}
